import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled, { useTheme } from "styled-components";
import Icon from "~/components-shared/Icon";
import { useTranslation } from "react-i18next";
const Wrapper = styled.span`
  display: inline-block;
  width: 16px;
  height: 16px;
  cursor: help;
  border-radius: 50%;
  background-color: ${_ref => {
  let {
    $value,
    theme
  } = _ref;
  return $value === 0 ? theme.colors.text.secondary : $value > 0 ? theme.colors.success.main : theme.colors.warning.main;
}};
  margin: 0 5px 0 10px;
  ${_ref2 => {
  let {
    $value,
    theme
  } = _ref2;
  return theme.shadows.outline(theme, false, $value === 0 ? theme.colors.text.secondary : $value > 0 ? theme.colors.success.main : theme.colors.warning.main);
}}

  &:hover {
    ${_ref3 => {
  let {
    $value,
    theme
  } = _ref3;
  return theme.shadows.outline(theme, true, $value === 0 ? theme.colors.text.secondary : $value > 0 ? theme.colors.success.main : theme.colors.warning.main);
}}
  }
`;
const StyledIcon = styled(Icon)`
  display: flex;
`;
const Circle = styled.i`
  border: 2px solid ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.background.primary;
}};
  border-radius: 50%;
  width: 8px;
  height: 8px;
  display: block;
  margin: 4px;
`;
const TrendArrow = _ref5 => {
  let {
    value,
    prevValue,
    tip,
    ...rest
  } = _ref5;
  const {
    colors
  } = useTheme();
  const {
    t
  } = useTranslation();
  if (value === undefined || prevValue === undefined) {
    return null;
  }
  const delta = value - prevValue;
  const percentage = value ? Math.abs(value - prevValue) / value * 100 : 0;
  const html = tip || `<strong>${t("TrendArrow.delta")}</strong><br /><strong style="font-size: 1.4em; line-height: 1.4em">${delta >= 0 ? "+" : ""}${delta.toFixed(2)}</strong> (${percentage.toFixed(0)}%)`;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $value: delta
  }, rest, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-html": html
  }), delta === 0 ? /*#__PURE__*/React.createElement(Circle, null) : /*#__PURE__*/React.createElement(StyledIcon, {
    src: "chevron",
    rotate: delta > 0 ? 0 : 180,
    color: colors.background.primary
  }));
};
export default TrendArrow;